import { RecoilEnv } from 'recoil';
import { environment } from './environments/environment';

if (environment.environment !== 'prod') {
  RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = false;
}
